import React, { useState, useEffect } from 'react';
import ParentDocCard from '../../common/ParentDocCard';
import { FileUpload } from '../../../common/formElements/FileUpload';
import DocsLink from '../../../common/custom/DocsLink';
import { FileTable } from './FileTable';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { ParentContentCardMultiHeader } from '../../common/ParentContentCardMultiHeader';
import { useParams } from 'react-router-dom';
import { HTMLFileTable } from './HTMLFileTable';

export const CustomTheme = ({
  customThemeFiles,
  customHtmlFiles,
  customHtmlCdns,
  loadCustomThemeFiles,
  loadCustomHtmlFiles,
  deleteCustomThemeFile,
  deleteFlag,
}) => {
  const [toggle, setToggle] = useState(false);
  const [htmlUploadModal, setHtmlUploadModal] = useState(false);
  const { projectId, version } = useParams();

  const openHtmlUploadModal = () => {
    setHtmlUploadModal(true);
  };

  const closeHtmlUploadModal = () => {
    setHtmlUploadModal(false);
  };

  return (
    <>
      <Modal isOpen={toggle} toggle={() => setToggle(false)} backdrop="static">
        <ModalHeader toggle={() => setToggle(false)} className="border-bottom">
          <strong>Upload Custom Theme</strong>
        </ModalHeader>
        <ModalBody className="d-flex flex-column justify-content-center align-items-center">
          <FileUpload
            url={`${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/custom-theme/file`}
            projectId={projectId}
            version={version}
            maxFiles={1}
            maxSizeBytes="50971520"
            accept=".zip"
            fileIcon="customTheme"
            submitAction={() => loadCustomThemeFiles({ projectId, version })}
          />
        </ModalBody>
      </Modal>

      <Modal isOpen={htmlUploadModal} toggle={closeHtmlUploadModal} backdrop="static">
        <ModalHeader toggle={closeHtmlUploadModal} className="border-bottom">
          <strong>Upload HTML File</strong>
        </ModalHeader>
        <ModalBody className="d-flex flex-column justify-content-center align-items-center">
          <FileUpload
            url={`${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/custom-theme-files/file`}
            projectId={projectId}
            version={version}
            maxFiles={1}
            maxSizeBytes="50971520"
            accept="text/html"
            fileIcon="customTheme Files"
            submitAction={() => loadCustomHtmlFiles({ projectId, version })}
          />
        </ModalBody>
      </Modal>
      <ParentContentCardMultiHeader
        title="Custom Theme"
        bgColor="drapcode-violet"
        icon="customTheme"
        projectId={projectId}
        version={version}
        CtaComponent={
          !customThemeFiles || customThemeFiles.length === 0 ? (
            <div className="col-md-12 col-lg-12 mt-2 text-right">
              <button className="btn btn-theme-submit btn-md" onClick={() => setToggle(true)}>
                <i className="wb webconnect-cloud-arrow-up-fill"></i>&nbsp;Upload Theme&nbsp;
              </button>
            </div>
          ) : (
            <div className="col-md-12 col-lg-12 mt-2 text-right">
              <button className="btn btn-theme-submit btn-md" onClick={openHtmlUploadModal}>
                <i className="wb webconnect-cloud-arrow-up-fill"></i>&nbsp;Upload Theme Files&nbsp;
              </button>
            </div>
          )
        }
      >
        <FileTable
          files={customThemeFiles}
          projectId={projectId}
          version={version}
          deleteAction={deleteCustomThemeFile}
          deleteFlag={deleteFlag}
        />
        <HTMLFileTable customHtmlCdns={customHtmlFiles ? customHtmlFiles : customHtmlCdns} />
      </ParentContentCardMultiHeader>
      <ParentDocCard>
        <h5>
          <b>About Custom Theme</b>
        </h5>
        <p>
          A custom theme refers to a personalized design or appearance applied to a website,
          application, or user interface. It involves modifying the visual elements such as colors,
          typography, layout, and graphics to create a unique look and feel that aligns with
          specific branding, aesthetics, or user preferences.
        </p>
      </ParentDocCard>
    </>
  );
};
